// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"6929ab5d","126":"0e2b2af4","199":"74f1d323","397":"7af775e6","453":"258b012d","787":"b222b45b","929":"6e8facc8"}[chunkId] + ".chunk.js";
};